import {i18n} from "../main";

export const TRANSPORT_TYPES = {
  CAR: 0,
  BUS: 2,
  OTHER: 1,
  VOLUNTEER: 3
};

export const TRANSPORT_OPTIONS = [{
  label: i18n.t('transportTypes.Car'),
  value: TRANSPORT_TYPES.CAR
}, {
  label: i18n.t('transportTypes.Other'),
  value: TRANSPORT_TYPES.OTHER
}, {
  label: i18n.t('transportTypes.Bus'),
  value: TRANSPORT_TYPES.BUS
}];

export const TRANSPORT_OPTIONS_WITHOUT_BUS =  [{
  label: i18n.t('transportTypes.Car'),
  value: TRANSPORT_TYPES.CAR
}, {
  label: i18n.t('transportTypes.Other'),
  value: TRANSPORT_TYPES.OTHER
}];
